/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RefreshTokenRequestDto } from '../../models/refresh-token-request-dto';
import { TokenResponseDto } from '../../models/token-response-dto';

export interface ApiAuthRefreshTokenPost$Params {
    /**
     * application/json
     */
    body: RefreshTokenRequestDto;
}

export function apiAuthRefreshTokenPost(
    http: HttpClient,
    rootUrl: string,
    params: ApiAuthRefreshTokenPost$Params,
    context?: HttpContext,
): Observable<StrictHttpResponse<TokenResponseDto>> {
    const rb = new RequestBuilder(rootUrl, apiAuthRefreshTokenPost.PATH, 'post');
    if (params) {
        rb.body(params.body, 'application/json');
    }

    return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
            return r as StrictHttpResponse<TokenResponseDto>;
        }),
    );
}

apiAuthRefreshTokenPost.PATH = '/api/auth/refresh-token';
